import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { IoMdTrophy as TrophyIcon } from 'react-icons/io';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  icon: {
    composes: ['is-absolute'],
    left: 0,
  },
  score: {
    composes: ['is-relative', 'no-overflow'],
    height: '100%',
    width: '100%',
  },
  trophythumb: {
    composes: ['is-overlay'],
    height: '100%',
    zIndex: 0,
  },
});

const TrophyThumbComponent = React.memo(({ percent }) => {
  const classes = useStyles();
  const score = 100 - percent;
  return (
    <div
      className={classnames(
        classes.trophythumb,
        'smart-maps-trophies-overall-trophy-thumb'
      )}>
      <div className={classes.score} style={{ top: `${score}%` }}>
        <TrophyIcon
          className={classes.icon}
          size={40}
          style={{ top: `-${score}%` }}
        />
      </div>
    </div>
  );
});

TrophyThumbComponent.propTypes = {
  percent: PropTypes.number.isRequired,
};

TrophyThumbComponent.displayName = 'TrophyThumbComponent';

export default TrophyThumbComponent;
